/*
 * drag-scroll — enables click-and-drag horizontal scrolling (mouse only) on any element
 * marked with [data-drag-scroll]. Touch devices keep their native scrolling untouched.
 *
 * Used for the product gallery thumbnail slider so it can be dragged with the mouse, not
 * only scrolled with a trackpad/wheel. A drag is suppressed from turning into a click so
 * dragging across thumbnails doesn't accidentally select one.
 */
(function () {
  var DRAG_THRESHOLD = 5;

  function enhance(element) {
    if (element.dataset.dragScrollReady === 'true') {
      return;
    }
    element.dataset.dragScrollReady = 'true';

    var isDown = false;
    var didDrag = false;
    var startX = 0;
    var startScrollLeft = 0;

    element.addEventListener('pointerdown', function (event) {
      if (event.pointerType !== 'mouse' || event.button !== 0) {
        return;
      }
      isDown = true;
      didDrag = false;
      startX = event.clientX;
      startScrollLeft = element.scrollLeft;
    });

    element.addEventListener('pointermove', function (event) {
      if (!isDown) {
        return;
      }
      var dx = event.clientX - startX;
      if (!didDrag && Math.abs(dx) < DRAG_THRESHOLD) {
        return;
      }
      didDrag = true;
      element.classList.add('is-dragging');
      element.scrollLeft = startScrollLeft - dx;
      event.preventDefault();
    });

    function release() {
      if (!isDown) {
        return;
      }
      isDown = false;
      element.classList.remove('is-dragging');
    }

    element.addEventListener('pointerup', release);
    element.addEventListener('pointercancel', release);
    element.addEventListener('pointerleave', release);

    // Stop a drag from triggering a click (thumbnail selection) on the element it ended on.
    element.addEventListener(
      'click',
      function (event) {
        if (didDrag) {
          event.preventDefault();
          event.stopPropagation();
          didDrag = false;
        }
      },
      true
    );
  }

  function init(root) {
    (root || document).querySelectorAll('[data-drag-scroll]').forEach(enhance);
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
